import type { Warnings } from '@app/services/rtkQuery/Records/types';
import { generateSpanWithDataTestId } from '@app/shared/utils';

export const padIdWithZeros = (id: number, totalLength: number = 6): string => {
  const idStr = String(id);
  if (idStr.length >= totalLength) return idStr;

  return idStr.padStart(totalLength, '0');
};

export const getWarningModalTitle = (
  warnings: Warnings[] | undefined
): string | JSX.Element => {
  if (!warnings || warnings.length === 0) return '';
  const type = warnings?.[0]?.Type;

  switch (type) {
    case 'intersection':
      return generateSpanWithDataTestId(
        'Наложение записей',
        'overlay-records-popup-title'
      );
    case 'outside-schedule':
      return 'Вне графика работы';
    default:
      return 'Внимание!';
  }
};

export const getModalDataTestId = (
  warnings: Warnings[] | undefined
): string => {
  if (!warnings || warnings.length === 0) return '';
  const type = warnings?.[0]?.Type;

  switch (type) {
    case 'intersection':
      return 'overlay-records-popup';
    case 'outside-schedule':
      return '';
    default:
      return '';
  }
};
